// extracted by mini-css-extract-plugin
export default {"block":"PickupPointsGroup_block__X0JQo","points":"PickupPointsGroup_points__0StrW"};